"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(){
        this.board = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.isStarted = false;
        this.gameStarted = false;
    }
    moveLeft() {
        for(let i = 0; i < 4; i++){
            const numbers = this.board[i].filter((val)=>val !== 0);
            for(let j = 0; j < numbers.length; j++)if (numbers[j] === numbers[j + 1]) {
                numbers[j] *= 2;
                this.score += numbers[j];
                numbers[j + 1] = 0;
                j++;
            }
            const result = numbers.filter((num)=>num !== 0);
            while(result.length < 4)result.push(0);
            this.board[i] = result;
        }
    }
    moveRight() {
        for(let i = 0; i < 4; i++){
            const numbers = this.board[i].filter((val)=>val !== 0);
            for(let j = numbers.length - 1; j >= 0; j--)if (numbers[j] === numbers[j - 1]) {
                numbers[j] *= 2;
                this.score += numbers[j];
                numbers[j - 1] = 0;
                j--;
            }
            const result = numbers.filter((num)=>num !== 0);
            while(result.length < 4)result.unshift(0);
            this.board[i] = result;
        }
    }
    moveUp() {
        for(let i = 0; i < 4; i++){
            const columns = [];
            for(let j = 0; j < 4; j++)columns.push(this.board[j][i]);
            const numbers = columns.filter((val)=>val !== 0);
            for(let j = 0; j < numbers.length; j++)if (numbers[j] === numbers[j + 1]) {
                numbers[j] *= 2;
                this.score += numbers[j];
                numbers[j + 1] = 0;
                j++;
            }
            const result = numbers.filter((num)=>num !== 0);
            while(result.length < 4)result.push(0);
            for(let j = 0; j < 4; j++)this.board[j][i] = result[j];
        }
    }
    moveDown() {
        for(let i = 0; i < 4; i++){
            const columns = [];
            for(let j = 0; j < 4; j++)columns.push(this.board[j][i]);
            const numbers = columns.filter((val)=>val !== 0);
            for(let j = numbers.length - 1; j >= 0; j--)if (numbers[j] === numbers[j - 1]) {
                numbers[j] *= 2;
                this.score += numbers[j];
                numbers[j - 1] = 0;
                j--;
            }
            const result = numbers.filter((num)=>num !== 0);
            while(result.length < 4)result.unshift(0);
            for(let j = 0; j < 4; j++)this.board[j][i] = result[j];
        }
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board;
    }
    getStatus() {
        for(let i = 0; i < 4; i++){
            if (this.board[i].includes(2048)) return "win";
        }
        if (this.canMove()) return this.isStarted ? "playing" : "idle";
        return "lose";
    }
    start() {
        const indexOfRow = Math.floor(Math.random() * 4);
        const indexOfColumn = Math.floor(Math.random() * 4);
        const chanceNumber = Math.floor(Math.random() * 101);
        let number;
        if (chanceNumber < 10) number = 4;
        else number = 2;
        this.board[indexOfRow][indexOfColumn] = number;
        this.gameStarted = true;
        this.isStarted = true;
    }
    restart() {
        const indexOfRow = Math.floor(Math.random() * 4);
        const indexOfColumn = Math.floor(Math.random() * 4);
        const chanceNumber = Math.floor(Math.random() * 101);
        let number;
        this.score = 0;
        if (chanceNumber < 10) number = 4;
        else number = 2;
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 4; j++)if (indexOfRow === i && indexOfColumn === j) this.board[i][j] = number;
            else this.board[i][j] = 0;
        }
    }
    addNewNumber() {
        if (this.gameStarted) {
            let indexOfRow = Math.floor(Math.random() * 4);
            let indexOfColumn = Math.floor(Math.random() * 4);
            const chanceNumber = Math.floor(Math.random() * 101);
            let number;
            let check = true;
            while(check){
                if (!this.canMove()) check = false;
                if (this.board[indexOfRow][indexOfColumn] === 0) {
                    check = false;
                    if (chanceNumber < 10) number = 4;
                    else number = 2;
                    this.board[indexOfRow][indexOfColumn] = number;
                } else {
                    indexOfRow = Math.floor(Math.random() * 4);
                    indexOfColumn = Math.floor(Math.random() * 4);
                }
            }
        }
    }
    canMove() {
        const state = this.board;
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            if (state[i][j] === 0) return true;
            if (j < 3 && state[i][j] === state[i][j + 1]) return true;
            if (i < 3 && state[i][j] === state[i + 1][j]) return true;
        }
        return false;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$rows = document.querySelectorAll(".field-row");
const $09e991522ca7e64e$var$score = document.querySelector(".game-score");
const $09e991522ca7e64e$var$button = document.querySelector("button");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$gameField = [];
let $09e991522ca7e64e$var$firstMove = false;
$09e991522ca7e64e$var$rows.forEach((row)=>{
    const cells = row.querySelectorAll("td");
    $09e991522ca7e64e$var$gameField.push(cells);
});
const $09e991522ca7e64e$var$handleKeyPress = (e)=>{
    const keys = [
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown"
    ];
    if (!keys.includes(e.key)) return;
    e.preventDefault();
    if ($09e991522ca7e64e$var$game.getStatus() === "win" || $09e991522ca7e64e$var$game.getStatus() === "lose") return;
    if (!$09e991522ca7e64e$var$firstMove) {
        $09e991522ca7e64e$var$firstMove = true;
        $09e991522ca7e64e$var$game.start();
    }
    const prevState = JSON.stringify($09e991522ca7e64e$var$game.getState());
    if (e.key === "ArrowLeft") $09e991522ca7e64e$var$game.moveLeft();
    if (e.key === "ArrowRight") $09e991522ca7e64e$var$game.moveRight();
    if (e.key === "ArrowUp") $09e991522ca7e64e$var$game.moveUp();
    if (e.key === "ArrowDown") $09e991522ca7e64e$var$game.moveDown();
    if (prevState !== JSON.stringify($09e991522ca7e64e$var$game.getState())) $09e991522ca7e64e$var$game.addNewNumber();
    $09e991522ca7e64e$var$changeButton();
    $09e991522ca7e64e$var$updateGameInterface();
};
document.addEventListener("keyup", $09e991522ca7e64e$var$handleKeyPress);
$09e991522ca7e64e$var$button.addEventListener("click", (e)=>{
    if (e.target.classList.contains("start")) {
        $09e991522ca7e64e$var$changeButton();
        $09e991522ca7e64e$var$firstMove = true;
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$updateGameInterface();
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$changeButton();
        $09e991522ca7e64e$var$updateGameInterface();
    }
});
function $09e991522ca7e64e$var$updateGameInterface() {
    $09e991522ca7e64e$var$showFields();
    $09e991522ca7e64e$var$score.textContent = $09e991522ca7e64e$var$game.getScore();
    const gameStatus = $09e991522ca7e64e$var$game.getStatus();
    if (gameStatus === "win") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    else if (gameStatus === "lose") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
}
function $09e991522ca7e64e$var$showFields(field = $09e991522ca7e64e$var$gameField, state = $09e991522ca7e64e$var$game.getState()) {
    for(let i = 0; i < field.length; i++)for(let j = 0; j < field[i].length; j++){
        const cell = field[i][j];
        const value = state[i][j];
        cell.textContent = "";
        cell.className = "field-cell";
        if (value !== 0) {
            cell.classList.add(`field-cell--${value}`);
            cell.textContent = value;
        }
    }
}
function $09e991522ca7e64e$var$changeButton() {
    if ($09e991522ca7e64e$var$button.classList.contains("start")) {
        $09e991522ca7e64e$var$button.classList.remove("start");
        $09e991522ca7e64e$var$button.classList.add("restart");
        $09e991522ca7e64e$var$button.textContent = "Restart";
    }
    if (!$09e991522ca7e64e$var$messageStart.classList.contains("hidden")) $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    if (!$09e991522ca7e64e$var$messageWin.classList.contains("hidden")) $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    if (!$09e991522ca7e64e$var$messageLose.classList.contains("hidden")) $09e991522ca7e64e$var$messageLose.classList.add("hidden");
}


//# sourceMappingURL=index.141c269e.js.map
